import { render, staticRenderFns } from "./MarkSheetTeacher.vue?vue&type=template&id=768f9fa7&"
import script from "./MarkSheetTeacher.vue?vue&type=script&lang=js&"
export * from "./MarkSheetTeacher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports